<template>
    <div>
        <div class="row mt-5">
            <div class="col-md-12">
                <h2>{{ $t('shop.selected_vehicle') }}</h2>
            </div>
        </div>

        <div class="row mb-2">
            <div class="col-md-12 mb-2 vignette-col">
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <div
                                class="mt-3 row justify-content-center"
                                :class="{'d-none': selectedOption >= 0}"
                            >
                                <div
                                    v-for="(vehicle, index) in vehicles"
                                    :key="JSON.stringify(vehicle)"
                                    class="col-12 col-md-6 mb-2"
                                    :class="{ 'text-md-right': 0 === getIndexForVignetteOption(index) }"
                                >
                                    <div class="checkbox-button-container">
                                        <input
                                            type="radio"
                                            class="checkbox"
                                            name="vehicle_options"
                                            :value="index"
                                            :id="'vignette_option_' + index"
                                            :class="{ 'is-invalid': formErrors.option_id }"
                                            @click="
                                                $emit('input-change', 'option_id');
                                                scrollToPart('productSelection');
                                            "
                                            @change="
                                                selectVehicle(vehicle);
                                                $emit('input-change', 'option_id');
                                            "
                                            v-model="selectedOption"
                                            required
                                        />
                                        <label
                                            :for="'vignette_option_' + index"
                                            class="mb-0 shop-product-card alternative bg-white px-4 py-2 rounded text-center text-reset-case"
                                            :class="{ highlighted: index === selectedOption }"
                                        >
                                            <template>
                                                <div class="h5 mr-1 shop-vehicle-icon">
                                                    <i :class="getVehicleIcon(vehicle[0].vehicle_type)"></i>
                                                </div>
                                                <h2 class="title mt-2 mb-0">
                                                    {{ $t('vehicleTypes.' + vehicle[0].vehicle_type) }}
                                                </h2>
                                                <small class="mt-1 mb-0">{{
                                                    $t(
                                                        'vehicleTypes.' +
                                                        vehicle[0].vehicle_type +
                                                        '_description'
                                                    )
                                                }}</small>
                                            </template>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'OrderFormVehicleSelection',

    props: [
        'vignetteProducts',
        'vignetteOptions',
        'selectedVignetteOption',
        'isMobile',
        'vehicles',
        'formErrors',
        'defaultSelectedProduct',
        'defaultSelectedOption',
    ],

    data() {
        return {
            initialScroll: true,
            scrolledToVehicle: false,
            scrolledToProducts: false,
            selectedOption: this.selectedVignetteOption,
            selectedOptionUrlName: '',
            selectedOptionUrlNames: {},
            selectedVignetteProducts: this.vignetteProducts,
        };
    },

    computed: {
        selectedVehicle() {
            if (this.selectedOption) {
                return this.vehicles[this.selectedOption][0];
            }

            return {};
        },
    },

    watch: {
        selectedOption() {
            this.updateField('selectedVehicle', this.selectedVehicle);
            this.updateField('selectedProductType', 'vignette');
            this.updateField('vignetteProducts', this.selectedVignetteProducts);
        },
    },

    methods: {
        updateField(field, value) {
            this.$emit('field-updated', {field: field, value: value});
        },

        scrollToPart(scroll = null, anchor = null) {
            let cb = null;

            if (!this.scrolledToVehicle && this.initialScroll) {
                return;
            } else if (scroll === 'orderForm' && !this.scrolledToProducts) {
                this.scrolledToProducts = true;
                return;
            }

            switch (scroll) {
                case 'anchor':
                    this.scrolledToVehicle = true;
                    cb = () => {
                        setTimeout(() => {
                            window.scrollTo(0,0);
                            window.scrollTo(
                                0,
                                document.querySelector(anchor).getBoundingClientRect().top -
                                document.getElementById('topnav').getBoundingClientRect().height
                            );
                        }, 100);
                    };
                    break;

                case 'productSelection':
                    this.scrolledToProducts = true;
                    cb = () => {
                        setTimeout(() => {
                            const elementY = document.getElementById('optionSelection').getBoundingClientRect().top;
                            const topNavHeight = document.querySelector('#topnav').getBoundingClientRect().height;
                            const windowY = window.scrollY;

                            window.scrollTo(0, windowY + elementY - topNavHeight);
                        }, 100);
                    };
                    break;

                default:
                    break;
            }

            this.initialScroll = !this.initialScroll;

            this.$nextTick(cb);
        },

        getIndexForVignetteOption(id) {
            if (!this.vignetteOptions) {
                return -1;
            }

            id = '' + id;

            const ids = Object.keys(this.vignetteOptions);
            for (let i = 0; i < ids.length; i++) {
                if (ids[i] === id) {
                    return i;
                }
            }

            return -1;
        },

        getVehicleIcon(vehicle) {
            const iconBaseClass = 'mdi ';

            switch (vehicle) {
                case 'car':
                    return iconBaseClass + 'mdi-car';
                case 'bike':
                    return iconBaseClass + 'mdi-motorbike';
                default:
                    return '';
            }
        },

        selectVehicle(vehicle) {
            // Before we update the data we have to read the previous url definitions.
            const prevUrlName = this.selectedOptionUrlName;
            const prevUrlNames = this.selectedOptionUrlNames;
            const firstVehicleOption = vehicle[0];

            // Set vehicle
            this.selectedVignetteProducts = vehicle.sort((a, b) => a.product.product_sort - b.product.product_sort);

            this.$emit('vehicle-selected');

            // Reset the selected product
            this.selectedOptionUrlName = firstVehicleOption.slug_name;
            this.selectedOptionUrlNames = firstVehicleOption.slugNames;
            this.scrolledToProducts = false;

            // In the case the product has an url_name definition, we should update
            // the history of browser to give the user a history back option.
            if (
                typeof firstVehicleOption.slug_name === 'string' &&
                firstVehicleOption.slug_name.length &&
                window.history &&
                !window.location.pathname.endsWith(firstVehicleOption.slug_name)
            ) {
                // Default history target url
                const baseUrl = window.location.href + (window.location.href.endsWith('/') ? '' : '/');
                let historyUrl = baseUrl + firstVehicleOption.slug_name;

                // In the case we have an previous url name, we should replace the old one.
                if (typeof prevUrlName === 'string' && prevUrlName.length) {
                    historyUrl = window.location.href.replace(prevUrlName, firstVehicleOption.slug_name);
                }

                if (this.defaultSelectedOption > 0) {
                    // Do nothing. This URL is only directly reachable by the configurator.
                } else {
                    window.history.pushState('', '', historyUrl);
                }

                // In the case that the product has multiple url translations, we should
                // update the locales in the #locales-submenu.
                if (
                    typeof firstVehicleOption.slugNames === 'object' &&
                    (Object.keys(firstVehicleOption.slugNames) || []).length
                ) {
                    const navItems = document.querySelectorAll('#locales-submenu li');

                    for (const navItem of navItems) {
                        const locale = navItem.dataset.locale,
                            link = navItem.querySelector('a'),
                            oldSlugName = prevUrlNames[locale] || null,
                            newSlugName = firstVehicleOption.slugNames[locale] || null;

                        // We're not able to handle the update of url
                        if (
                            typeof oldSlugName !== 'string' ||
                            !oldSlugName.length ||
                            typeof newSlugName !== 'string' ||
                            !newSlugName.length
                        ) {
                            return;
                        }

                        link.href = link.href.replace(oldSlugName, newSlugName);
                    }
                }
            }

            this.$emit('show-loading-animation');
            this.$emit('input-change');

            // Preselect product only mobile if default product is set
            if (
                this.defaultSelectedProduct !== null &&
                this.isMobile
            ) {
                this.selectedVignetteProducts.forEach((product) => {
                    if (product.product_id === this.defaultSelectedProduct.product_id) {
                        this.$nextTick(() => {
                            const el = document.querySelector('[url_name="' + product.product.url_name + '"] .btn');
                            if (el !== null) {
                                el.click();
                                this.scrolledToProducts = true;
                            }
                        });
                    }
                });
            }

            // Check for any anchors to scroll into
            const anchorTag = this.getAnchorTag();
            if (
                anchorTag !== null &&
                anchorTag !== '' &&
                !this.scrolledToVehicle &&
                this.selectedVehicle
            ) {
                this.$nextTick(() => {
                    this.scrollToPart('anchor', anchorTag);
                });
            }

            this.scrolledToVehicle = true;
        },

        getAnchorTag() {
            return window.location.hash;
        },
    },

    mounted() {
        if (this.defaultSelectedProduct !== null && typeof this.defaultSelectedProduct.vehicle_type_code === 'string') {
            this.$nextTick(() => {
                const radio = document.querySelector(
                    `[for="vignette_option_${this.defaultSelectedProduct.vehicle_type_code}"]`
                );

                if (radio === null) {
                    return;
                }

                radio.click();
            });
        }
    },
};
</script>
